import React from 'react'

/**
 * This context indicates to the loader whether it should be playing it's animation or not
 * Mostly used to ensure 'off screen' loaders are not unnecssarily playing their animation
 */
const LoaderPlayStateContext = React.createContext<'running' | 'paused'>('running')

export default LoaderPlayStateContext
